var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTop2Bottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "78px",
    height: "31px",
    viewBox: "0 0 78 31",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "NO.2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "4.80786903%",
    y1: "41.2670767%",
    x2: "72.478088%",
    y2: "46.3641431%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E7F0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CED7E1",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "2.04964918%",
    y1: "13.8044035%",
    x2: "100%",
    y2: "13.8044035%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF3F9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8E1EE",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("text", {
    id: "text-3",
    fontFamily: "FZZYK--GBK1-0, FZZongYi-M05",
    fontSize: 12,
    fontWeight: "normal",
    "line-spacing": 20,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 24.4973629,
    y: 11
  }, "NO.2")), /*#__PURE__*/React.createElement("filter", {
    x: "-12.1%",
    y: "-12.5%",
    width: "124.1%",
    height: "135.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.756436803   0 0 0 0 0.816966702   0 0 0 0 0.897673234  0 0 0 1 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u9996\\u9875-\\u6253\\u5F00",
    transform: "translate(-35.000000, -211.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-7",
    transform: "translate(25.000000, 136.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-5",
    transform: "translate(10.000000, 32.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "NO.2",
    transform: "translate(0.000000, 44.568676)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-3",
    transform: "translate(0.000000, 1.431324)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9303787,7.78915075 C5.6064342,9.99037607 1.82524275,11.5144131 0.586804374,12.3612618 C-0.0766480374,12.8232558 -0.177516322,13.2584147 0.284199522,13.6667384 L6.20414809,18.4990216 C6.91353324,19.2067392 7.26822581,19.9862663 7.26822581,20.8376032 L7.26822581,27.1157564 C7.42485644,27.8291776 7.93783321,28.1108995 8.80715614,27.9609221 C18.2630525,24.2059704 24.8886657,22.4068025 28.6839956,22.5634186 L20.0536942,5.47595256 L19.8365243,5.01073275 L11.9303787,7.78915075 Z",
    id: "\\u8DEF\\u5F84-2",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2463831,7.78915075 C54.9224386,9.99037607 51.1412471,11.5144131 49.9028087,12.3612618 C49.2393563,12.8232558 49.138488,13.2584147 49.6002039,13.6667384 L55.5201525,18.4990216 C56.2295376,19.2067392 56.5842302,19.9862663 56.5842302,20.8376032 L56.5842302,27.1157564 C56.7408608,27.8291776 57.2538376,28.1108995 58.1231605,27.9609221 C67.5790569,24.2059704 74.20467,22.4068025 78,22.5634186 L69.3696986,5.47595256 L69.1525286,5.01073275 L61.2463831,7.78915075 Z",
    id: "\\u8DEF\\u5F84-2",
    fill: "url(#linearGradient-1)",
    transform: "translate(63.658002, 16.505366) scale(-1, 1) translate(-63.658002, -16.505366) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8357213,2.64748557 C13.107091,10.8019729 14.9614501,16.4463477 16.3987986,19.58061 C24.0491814,17.5304476 31.6067746,16.5053664 39.0715783,16.5053664 C47.9397861,16.6220563 55.3584212,17.5379349 61.3274838,19.2530024 C64.5193503,11.2763307 66.3647994,5.74115845 66.863831,2.64748557 C64.589538,1.52373203 59.3519556,0.741120452 51.1510839,0.299650847 C45.9650312,0.0998836156 41.9385294,0 39.0715783,0 C33.4291477,0 29.9666201,0.0488782731 28.6839956,0.146634819 C19.7180398,0.335002198 13.85911,1.01547007 11.1072064,2.18803845 L10.8357213,2.64748557 Z",
    id: "\\u8DEF\\u5F84-3",
    fill: "url(#linearGradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1389151,19.58061 L28.6839956,22.5634186 L26.1245968,17.4788961 C21.344206,18.319979 18.2487192,18.9841295 16.8381366,19.4713478 L17.1389151,19.58061 Z",
    id: "\\u8DEF\\u5F84-4",
    fill: "#C7CDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.487792,19.3392898 L61.3274838,22.5634186 L58.6853252,17.363954 C53.849694,18.1361013 50.726587,18.7657841 49.3160044,19.2530024 L49.487792,19.3392898 Z",
    id: "\\u8DEF\\u5F84-4",
    fill: "#C7CDD7",
    transform: "translate(55.321744, 19.963686) scale(-1, 1) translate(-55.321744, -19.963686) "
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#FFFFFF",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    filter: "url(#filter-4)",
    xlinkHref: "#text-3"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#text-3"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTop2Bottom);
export default __webpack_public_path__ + "static/media/icon-top2-bottom.03fce8d6c634cd42d9b198b220622309.svg";
export { ForwardRef as ReactComponent };